// PrimeVue Components
import Card from 'primevue/card'
import InputText from 'primevue/inputtext'
import Password from 'primevue/password'
import Button from 'primevue/button'
import Menubar from 'primevue/menubar'
import Message from 'primevue/message'
import ProgressSpinner from 'primevue/progressspinner'
import Toast from 'primevue/toast'
import Tooltip from 'primevue/tooltip'
import Checkbox from 'primevue/checkbox'
import DatePicker from 'primevue/datepicker'
import Select from 'primevue/select'
import InputNumber from 'primevue/inputnumber'
import Textarea from 'primevue/textarea'
import Paginator from 'primevue/paginator'
import ButtonGroup from 'primevue/buttongroup'
import ToggleButton from 'primevue/togglebutton'

export default {
  install(app) {
    // PrimeVue components
    app.component('PvCard', Card)
    app.component('PvInputText', InputText)
    app.component('PvPassword', Password)
    app.component('PvButton', Button)
    app.component('PvMenuBar', Menubar)
    app.component('PvMessage', Message)
    app.component('PvProgressSpinner', ProgressSpinner)
    app.component('PvToast', Toast)
    app.component('PvCheckbox', Checkbox)
    app.component('PvDatePicker', DatePicker)
    app.component('PvSelect', Select)
    app.component('PvInputNumber', InputNumber)
    app.component('PvTextarea', Textarea)
    app.component('PvPaginator', Paginator)
    app.component('PvButtonGroup', ButtonGroup)
    app.component('PvToggleButton', ToggleButton)

    app.directive('PvTooltip', Tooltip)
  }
}
